import { DialogUI } from '../../Interface';
import { useProduction } from '../../../hooks/useProduction';
import { useEffect } from 'react';
import { ProductionPage } from '../../Production/NewProduction/ProductionPage';

const ProductDialog = ({ open, handleClose, production, items, changed }) => {
  const productionState = useProduction();
  const { productionChanged, setProductionChanged } = changed;

  useEffect(() => {
    if (production && !productionState.loading) {
      productionState.setSelectedValues(production);
    }
  }, [production, productionState, productionState.loading]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Gyártás adatok'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1300px',
          },
        },
      }}
    >
      <div className="mt-5">
        <ProductionPage
          dialog={{
            handleClose: handleClose,
            productionChanged: productionChanged,
            setProductionChanged: setProductionChanged,
            isView: true,
          }}
          productionState={productionState}
          items={items}
        />
      </div>
    </DialogUI>
  );
};

export default ProductDialog;
